var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelPagesMembersArea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 192,
    viewBox: "0 0 128 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 192,
    fill: "#E0EEFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5c3.314 0 6 2.686 6 6 0 1.983-.962 3.74-2.444 4.833C22.19 17.141 24 19.86 24 23c0 2.5-4 4-8 4s-8-1.5-8-4c0-3.141 1.81-5.86 4.444-7.168C10.962 14.74 10 12.982 10 11c0-3.314 2.686-6 6-6zm0 12c-3.314 0-6 2.686-6 6 0 .803 2.612 2 6 2s6-1.197 6-2c0-3.314-2.686-6-6-6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z",
    transform: "translate(8 8)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 123)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 4,
    x: 19,
    y: 7,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 3,
    y: 5,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 5.17c.238-.227.625-.227.864 0 .22.211.237.542.05.77l-.05.056-5.111 4.833c-.22.21-.567.227-.807.049l-.057-.049-2.667-2.5c-.239-.228-.239-.597 0-.825.22-.21.567-.226.807-.048l.057.048 2.235 2.087 4.679-4.42z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 4,
    x: 19,
    y: 19,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 3,
    y: 17,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 4,
    x: 19,
    y: 31,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 3,
    y: 29,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 5.17c.238-.227.625-.227.864 0 .22.211.237.542.05.77l-.05.056-5.111 4.833c-.22.21-.567.227-.807.049l-.057-.049-2.667-2.5c-.239-.228-.239-.597 0-.825.22-.21.567-.226.807-.048l.057.048 2.235 2.087 4.679-4.42z",
    transform: "translate(0 24)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 4,
    x: 19,
    y: 43,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 3,
    y: 41,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 5.17c.238-.227.625-.227.864 0 .22.211.237.542.05.77l-.05.056-5.111 4.833c-.22.21-.567.227-.807.049l-.057-.049-2.667-2.5c-.239-.228-.239-.597 0-.825.22-.21.567-.226.807-.048l.057.048 2.235 2.087 4.679-4.42z",
    transform: "translate(0 36)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEFF",
    d: "M4 0h120c2.21 0 4 1.79 4 4v12H0V4c0-2.21 1.79-4 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 8,
    r: 3,
    fill: "#25CF1B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99C7FF",
    d: "M0 16.5L128 16.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    fill: "#F20D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 3,
    fill: "#F9C206"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    x: 36,
    y: 4,
    fill: "#FFF",
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 88)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 8,
    fill: "#338EFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 4,
    y: 12,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 4,
    y: 20,
    fill: "#99C7FF",
    rx: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelPagesMembersArea);
export default __webpack_public_path__ + "static/media/illustrations-funnel-pages-members-area.0913d245.svg";
export { ForwardRef as ReactComponent };